import React from "react";
import { Body, PrimaryButton, RegularButton } from "@components";
import locale from "@bonliva-crm/locale";
import { DialogActions, DialogContent } from "@material-ui/core";

type Props = {
  onClose: () => void;
  onRetry: () => void;
  error: string;
};

export const Fail: React.FC<Props> = (props) => {
  return (
    <>
      <DialogContent>
        {props.error && <Body display="block">{props.error}</Body>}
      </DialogContent>

      <DialogActions>
        <RegularButton onClick={props.onClose} style={{ marginLeft: 0 }}>
          {locale.Cancel}
        </RegularButton>
        <PrimaryButton onClick={props.onRetry}>{locale.Retry}</PrimaryButton>
      </DialogActions>
    </>
  );
};
